import PurchaseConfirmLayer from './PurchaseConfirmLayer';
import GiftAlertLayer from './GiftAlertLayer';
import ValidCompose, { InvalidTaskError } from '../../utils/ValidCompose';
import SubscriptionLayer from '../layer/SubscriptionLayer';
import { appOnlyQRCode, appOnlyPopupEvent } from './AppOnlyPurchase';
/* eslint consistent-return: 0 */

const ERROR_MESSAGE = {
  IS_SOLD_OUT: "IS_SOLD_OUT",
  IS_HAVE_SOLD_OUT: "IS_HAVE_SOLD_OUT",
  IS_GIFT_CARD_DEAL: "IS_GIFT_CARD_DEAL",
  SUBS_CNCL_RESV: "SUBS_CNCL_RESV",
  SUBS_NOT_MEMBER_RESV: "SUBS_NOT_MEMBER_RESV",
  SUBS_ERROR_RESV: "SUBS_ERROR_RESV",
  IS_CART_EMPTY: "IS_CART_EMPTY",
  IS_BUNDLE_ONLY: "IS_BUNDLE_ONLY",
};

/**
 * 구매하기 영역 UI toggle
 * 구매하기 버튼(바로구매, 카트담기, 티몬페이, 페이코)
 */
export default class Purchase {
  constructor() {
    if (!this.welContainer) {
      this.welContainer = $('div[data-role="prchWrap"]');
      this.setPurchaseHeightOnPc();

      this.bAVSale = TMON.oApp.htStorage.htStaticData.bAVSale;
      this.nBTNSize = TMON.oApp.htStorage.htStaticData.nBTNSize;
      this.isSale = TMON.oApp.htStorage.htStaticData.isSale;
      this.isSubsDeal = TMON.oApp.htStorage.htStaticData.htDealInfo.isSubsDeal;
      this.isAppOnly = TMON.htStaticData.htDealInfo.isAppOnly;

      // 새로고침시 로컬스토리지에 커스텀딜 액션이 있는지 검사한다. 로그인이 되어 있지 않다면 무시한다. (로그인 이후 액션이기 때문에)
      if (this.getCustomDealActionStorage() && TMON.bLogin) {
        this.setCustomDealActionStorage(false); // 기존 로컬스토리지는 삭제하고
        this.execCustomDealAction(); // 다시 로컬스토리지 액션을 태워주자.
      }

      if (this.isAppOnly && TMON.oApp.sPlatform === 'PW') appOnlyQRCode(); // PC 앱전용딜 고티몬 QRCode

      this.setEvent();
    }
  }

  // 구매하기
  update(sStorageKey) {
    if (sStorageKey === "innerCartItems") {
      const nInnerCartItemLength =
        TMON.oApp.htStorage.innerCartItems.aList.length;
      const hasSoldoutItem = TMON.oApp.htStorage.innerCartItems.aList.find(
        (item) => item.orderDealMax.soldOut
      ); // 매진상품 포함 여부
      const hasAvailableItem = !!TMON.oApp.htStorage.innerCartItems.aList.find(
        (item) => !item.orderDealMax.soldOut
      ); // 구매가능 상품 포함 여부
      if (nInnerCartItemLength === 0 || hasSoldoutItem) {
        // innerCart 에 아이템이 없거나 매진 상품이 있을 때
        if (TMON.oApp.sPlatform !== "PW") {
          // PC 에서는 innerCartItems 가 비어 있어도 구매하기, 카트담기 버튼을 비활성화하지 않는다. 모바일에서만 비활성화 한다.
          this.welContainer
            .find('[data-role="prchActionBtn"]')
            .attr("disabled", "disabled")
            .addClass("disabled");
        }
        this.welContainer.removeClass("hasItem");
      } else {
        // innerCart 에 아이템이 있고, 매진상품이 포함되어 있지 않을 때
        this.welContainer
          .find('[data-role="prchActionBtn"]:not(.forceDisabled)')
          .removeAttr("disabled")
          .removeClass("disabled");
        this.welContainer.addClass("hasItem");
      }
      if (
        nInnerCartItemLength > 0 &&
        !hasAvailableItem &&
        TMON.oApp.sPlatform === "PW"
      ) {
        // PC 에서는 innerCartItem 이 있고 매진상품만 담겨 있을 때 data-onclick=alert 을 추가한다. 이 애트리뷰트는 클릭시 '매진되었습니다' alert 을 띄우는 역할을 한다.
        this.welContainer
          .find('[data-role="prchActionBtn"]')
          .attr("data-onclick", "alert");
      } else if (
        nInnerCartItemLength > 0 &&
        hasSoldoutItem &&
        TMON.oApp.sPlatform === "PW"
      ) {
        // PC 에서는 innerCartItem 이 있고 매진상품이 포함되어 있을 때만 data-onclick=confirm 을 추가한다. 이 애트리뷰트는 클릭시 confirm 창을 띄우는 역할을 한다.
        this.welContainer
          .find('[data-role="prchActionBtn"]')
          .attr("data-onclick", "confirm");
      } else {
        this.welContainer
          .find('[data-role="prchActionBtn"]')
          .attr("data-onclick", "");
      }
      // TODO: LTC 페이코, 티몬페이 노출되고 있는 지 확인
    } else if (sStorageKey === "payCustomDeal") {
      const { bIsPayco, bIsTmonPay } = TMON.oApp.htStorage.payCustomDeals.data;

      let { nBTNSize } = this;

      if (TMON.view_mode === "app" && bIsTmonPay) {
        nBTNSize += 1;

        this.welContainer
          .find(".views.option")
          .removeClass(`col${this.nBTNSize}`)
          .addClass(`col${nBTNSize}`)
          .append(
            '<button type="button" data-role="prchActionBtn" class="tmonpay empha"><i>TMON PAY</i></button>'
          ); // TMON PAY의 TLCODE 추가
        this.nBTNSize = nBTNSize;
      } else if (TMON.view_mode === "app" && !bIsTmonPay && bIsPayco) {
        nBTNSize += 1; // Tmonpay > Payco

        this.welContainer
          .find(".views.option")
          .removeClass(`col${this.nBTNSize}`)
          .addClass(`col${nBTNSize}`)
          .append(
            '<button type="button" data-role="prchActionBtn" class="payco empha" data-tlarea="MWCB" data-tlord="3"><i>PAYCO</i></button>'
          );
        this.nBTNSize = nBTNSize;
      }
    } else if (sStorageKey === "scene") {
      this.setPurchaseHeightOnPc();
    } else if (sStorageKey === "purchaseDrawer") {
      if (TMON.oApp.htStorage.purchaseDrawer === "openBuy") {
        this.open("buy");
      } else if (TMON.oApp.htStorage.purchaseDrawer === "openGift") {
        this.open("gift");
      } else {
        this.close();
      }
    } else if (sStorageKey === "resizeFloatingInnerCart") {
      this.setPurchaseHeightOnPc();
    } else if (
      sStorageKey === "closeLayer" &&
      TMON.oApp.htStorage.closeLayer === "PurchaseConfirmLayer"
    ) {
      this.oPurchaseConfirmLayer.onClose();
    } else if (sStorageKey === "subscriptionConfirm") {
      this.subscriptionConfirmResult();
    }
  }

  onResize() {
    if (TMON.oApp.sPlatform === "PW") {
      this.setPurchaseHeightOnPc();
    }
  }

  onScroll() {
    if (TMON.oApp.sPlatform === "PW") {
      this.setPurchaseHeightOnPc();
    }
  }

  setPurchaseHeightOnPc() {
    if (TMON.oApp.sPlatform !== "PW") {
      return;
    }

    const welContainer = $("[data-role=prchWrap].deals_floating_opt");
    const welFloatingInner = welContainer.find("[data-role=floatInner]");
    const welFloatingInnerTopArea = welFloatingInner.find(".order_top");
    const welFloatingInnerBottomArea = welFloatingInner.find(".order_bottom");

    // Purchase Floating inner 영역 height 조정
    const nLastFixedComponentHeight = TMON.oApp.oUtil.getOuterHeight(
      $("._fixed:last")
    );
    const nVisibleDealsContainerHeight = TMON.oApp.oUtil.getVisibleHeight(
      $(".deals_container")
    );
    const nVisibleDealsContentsHeight = TMON.oApp.oUtil.getVisibleHeight(
      $(".deals_content")
    );
    const nWindowScrollTop = $(window).scrollTop();
    const nWindowHeight = $(window).height();
    const nDealContainerOffsetTop = $(".deals_container").offset().top;
    const nDealContainerHeight = TMON.oApp.oUtil.getOuterHeight(
      $(".deals_container")
    );
    const nStartPoint =
      nDealContainerOffsetTop - nLastFixedComponentHeight - nWindowScrollTop;
    const nEndPoint =
      nWindowHeight +
      nWindowScrollTop -
      (nDealContainerOffsetTop + nDealContainerHeight);
    const htInnerCss = {
      position: "relative",
      top: "auto",
      bottom: "auto",
      height: nVisibleDealsContentsHeight,
      minHeight: "600px",
    };
    if (nStartPoint >= 0 && nEndPoint < 0) {
      // Normal 상태
    } else if (nStartPoint < 0 && nEndPoint >= 0) {
      // footer 를 만나 밀려 올라가는 상태
      htInnerCss.position = "fixed";
      htInnerCss.bottom = nEndPoint;
      htInnerCss.height =
        nVisibleDealsContainerHeight -
        nLastFixedComponentHeight -
        parseInt($("._fixed:last").css("top"), 10);
    } else if (nStartPoint < 0 && nEndPoint < 0) {
      // float 이 시작된 상태
      htInnerCss.position = "fixed";
      htInnerCss.top =
        parseInt($("._fixed:last").css("top"), 10) + nLastFixedComponentHeight;
      htInnerCss.bottom = 0;
      htInnerCss.height = "auto";
    } else if (nStartPoint >= 0 && nEndPoint >= 0) {
      // purchase 영역이 화면 안에 모두 들어온 상태
    }
    welFloatingInner.css(htInnerCss);

    // Purchase Floating inner TOP 영역 height 조정
    const htTopCss = {
      height:
        TMON.oApp.oUtil.getOuterHeight(welFloatingInner) -
        TMON.oApp.oUtil.getOuterHeight(welFloatingInnerBottomArea),
    };
    welFloatingInnerTopArea.css(htTopCss);
  }

  setEvent() {
    const welController = $('[data-role="prchController"]');

    appOnlyPopupEvent(); // 앱전용딜 구매/응모하기 버튼 클릭 이벤트
    
    if (this.isSale) {
      // 옵션 레이어 열기
      welController.on("click", ".normal [data-role=openDrawer]", () => {
        // MW 앱전용딜 > 옵션 선택 없이 바로 앱이동 팝업 노출
        if (this.isAppOnly && TMON.oApp.sPlatform === 'MW') return;

        /**
         * 판매 중인데 optionInfo 값이 없는 경우
         * 스크립트 에러가 나지 않도록 return으로 빼주자
         * 정확한 원인이 파악되면 개선하도록 하자
         */
        if (!TMON.oApp.htStorage.optionInfo) return;

        this.setOptionLayerHeightOnMobile();
        const isSingleOption =
          !!TMON.oApp.htStorage.optionInfo &&
          TMON.oApp.htStorage.optionInfo.totalDepth === 1;
        if ($("body").hasClass("scene-optiondetail") && isSingleOption) {
          const nIndex = window.location.hash.split("&")[1].split("=")[1];
          const option = TMON.oApp.htStorage.optionList.data[nIndex];
          if (!option || option.orderDealMax.soldOut) {
            alert("선택하신 옵션의 판매가 종료되었습니다. 다시 확인해 주세요.");
            return;
          }

          TMON.oApp.setStorage("purchaseDrawer", "openBuy");
          TMON.oApp.setStorage("purchaseOption", {
            aKeyList: [option.optionNo],
            nCurrentDepth: 0,
            allDepthContainer: document.querySelector(
              'div[data-role="prchSelector"]'
            ),
          });
        } else {
          TMON.oApp.setStorage("purchaseDrawer", "openBuy");
        }
      });

      // 선물하기 버튼으로 옵션 레이어 열기
      welController.on(
        "click",
        ".normal [data-role=openDrawerWithGift]",
        () => {
          this.setOptionLayerHeightOnMobile();
          TMON.oApp.setStorage("purchaseDrawer", "openGift");
        }
      );

      // 바로구매(응모하기,구해하기 버튼)
      if (!this.isAppOnly || (this.isAppOnly && TMON.oApp.sPlatform === "MA")) { // PC/MW 앱전용딜 제외
        welController.on('click', '[data-type=buyNow]', e => {
          this.sendStatistics(e);
          this.buyNow(
            this.isSubsDeal ? this.subscriptionConfirm : this.buyTrigger,
            'buy'
          );
        });
      }

      // 커스텀딜
      welController.on("click", "[data-type=customDeal]", (e) => {
        this.sendStatistics(e);
        this.execCustomDealAction();
      });

      // 바로구매 TMON PAY
      welController.on("click", ".options .tmonpay.empha", this.buyTmonPay);

      // 바로구매 PAYCO
      welController.on("click", ".options .payco.empha", this.buyPayco);

      // 카트담기
      welController.on("click", "[data-type=addToCart]", (e) => {
        const sDataOnclick = $(e.currentTarget).attr("data-onclick");
        TMON.oApp.oApi.fetchApi("statisticsClick", {
          areaCode: $(e.currentTarget).attr("data-tlarea"),
          linkOrder: $(e.currentTarget).attr("data-tlord"),
          statisticsAdditionalInfo: {
            viewAdviceTargetDeal: TMON.htStaticData.isViewAdviceDeal,
          },
        });
        if (sDataOnclick === "alert") {
          alert("매진된 상품입니다.");
          return;
        }
        if (sDataOnclick === "confirm") {
          if (
            !confirm(
              "일시 품절이거나 매진된 상품이 포함되어 있습니다. 구매할 수 없는 상품을 제거하고 카트에 담으시겠습니까?"
            )
          ) {
            return;
          }
        }

        this.addToCart();
      });

      // 선물하기
      welController.on("click", "[data-type=buyGift]", (e) => {
        this.sendStatistics(e);
        this.buyGift(
          this.isSubsDeal ? this.subscriptionConfirm : this.buyGiftTrigger,
          "gift"
        );
      });

      // 옵션 레이어 닫기
      this.welContainer.on("click", ".toggle", () => {
        TMON.oApp.setStorage("purchaseDrawer", "close");
        $(".search_input").blur();
      });

      // PC 선물하기 버튼 레이어 열기
      this.welContainer.on("click", "#_giftToolButton", (e) => {
        const {
          dealType,
          statusType,
          partnerNo,
        } = TMON.oApp.htStorage.htStaticData.htDealInfo;
        if (
          ["PIN"].indexOf(dealType) !== -1 ||
          (dealType === "TOUR" && statusType === "AV" && partnerNo === 800286)
        ) {
          // 이쿠폰일 경우
          this.sendStatistics(e);
          this.buyGift(
            this.isSubsDeal ? this.subscriptionConfirm : this.buyGiftTrigger,
            "gift"
          );
        } else {
          // 각 레이어간의 z-index 우선순위를 설정한다.
          TMON.oApp.oUtil.setPopupLayerZIndex($("#_giftToolbox"));
          $("#_giftToolbox").toggle();
        }
      });

      // PC 선물하기 버튼 레이어 닫기
      this.welContainer.on("click", "#_giftToolCloseButton", () => {
        $("#_giftToolbox").hide();
      });
    } else {
      // 공유 후 구매 가능
      welController.on("click", "[data-type=share]", () => {
        TMON.oApp.oShareDealPopup.open();
      });
    }
  }

  clearEvent() {
    if (this.isSale) {
      const welController = $('[data-role="prchController"]');

      // 옵션 레이어 열기
      welController.off("click", "[data-role=openDrawer]");

      // 바로구매
      welController.off("click", "[data-type=buyNow]");

      // 커스텀딜
      welController.off("click", "[data-type=customDeal]");

      // 바로구매 TMON PAY
      welController.off("click", ".options .tmonpay.empha");

      // 바로구매 PAYCO
      welController.off("click", ".options .payco.empha");

      // 선물하기
      welController.off("click", "[data-type=buyGift]");

      // 카트 담기
      welController.off("click", "[data-type=addToCart]");

      // 옵션 레이어 닫기
      this.welContainer.off("click", ".toggle");

      // PC 선물하기 버튼 레이어 열기
      this.welContainer.off("click", "#_giftToolButton");

      // PC 선물하기 버튼 레이어 닫기
      this.welContainer.off("click", "#_giftToolCloseButton");
    }
  }

  setOptionLayerHeightOnMobile() {
    if (TMON.oApp.sPlatform === "PW") {
      return;
    }

    const nMaxHeight =
      $(window).height() -
      TMON.oApp.oUtil.getHeaderHeight() -
      $("[data-sticky-id=tab-navigation]").height() -
      $("[data-role=prchController]").height() -
      parseFloat(this.welContainer.find(".prch-total").css("height")) - // SDLUI-1245 총상품금액 표시 신규영역 높이 빼줌
      this.welContainer
        .find(".toggle")
        .first()
        .height(); // 상단 고정, 구매버튼, 옵션닫기 버튼을 모두 빼줌
    $("#_optionScroll").css("max-height", nMaxHeight);
  }

  close = () => {
    TMON.oApp.oUtil.showGoTopButtonFastScroll();
    this.welContainer.removeClass("open giftbox").addClass("close");

    if (TMON.sDevice !== "PW") {
      // Mobile에서 옵션 창 열린 경우 딜상세 배경 클릭시 옵션창 닫히도록 이벤트 설정 [SDLUI-2069]
      $("html").css("overflow", "");
      $("#view-default").off("touchstart", this.touchClose);
    }

    if (TMON.view_mode === "app") {
      // option 창 close -> pull to refresh 동작 하도록 변경
      TMON.app.callApp(
        "webview",
        "setWebProperties",
        '{"nestedScrollEnable": true}'
      );
    }
  };

  touchClose = (e) => {
    if (!e.target.closest('[data-role="prchWrap"]')) {
      this.close();
    }
  };

  open = async (btnType) => {
    if (this.bAVSale) {
      TMON.oApp.oUtil.hideGoTopButtonFastScroll();

      if (btnType === "gift") {
        this.welContainer.addClass("giftbox");
      }

      this.welContainer.removeClass("close").addClass("open");

      if (TMON.sDevice !== "PW") {
        // Mobile에서 옵션 창 열린 경우 딜상세 배경 클릭시 옵션창 닫히도록 이벤트 설정 [SDLUI-2069]
        $("html").css("overflow", "hidden");
        $("#view-default").on("touchstart", this.touchClose);
      }

      if (TMON.view_mode === "app") {
        // option 창 open -> pull to refresh 동작 하지 않도록 변경
        TMON.app.callApp(
          "webview",
          "setWebProperties",
          '{"nestedScrollEnable": false}'
        );
      }
    }
  };

  /**
   * 구매버튼 클릭정보 log 전송
   */
  sendStatistics = (e) => {
    TMON.oApp.oApi.fetchApi("statisticsClick", {
      areaCode: $(e.currentTarget).attr("data-tlarea"),
      linkOrder: $(e.currentTarget).attr("data-tlord"),
      statisticsAdditionalInfo: {
        viewAdviceTargetDeal: TMON.htStaticData.isViewAdviceDeal,
      },
    });
  };

  buyVerify = (payload) => {
    const sDataOnclick = $("[data-type=buyNow]").attr("data-onclick");
    if (sDataOnclick === "alert") {
      throw new InvalidTaskError(ERROR_MESSAGE.IS_SOLD_OUT);
    }
    if (sDataOnclick === "confirm") {
      throw new InvalidTaskError(ERROR_MESSAGE.IS_HAVE_SOLD_OUT);
    } else if (TMON.htStaticData.isGiftCardDeal) {
      throw new InvalidTaskError(ERROR_MESSAGE.IS_GIFT_CARD_DEAL);
    }

    return payload;
  };

  buyTrigger = () => {
    TMON.oApp.setStorage("validateBuyNow", { type: "default" });
  };

  buyNow = (callback, type) => {
    if (
      !this.purchaseGuard(
        this.buyVerify,
        this.cartManagerVerify,
        this.subscriptionVerify
      )
    ) {
      return;
    }

    if (callback && typeof callback === "function") {
      callback(type);
    }
  };

  handleShowPurchaseConfirmLayer = () => {
    if (this.oPurchaseConfirmLayer) {
      this.oPurchaseConfirmLayer.open();
      return;
    }
    this.oPurchaseConfirmLayer = new PurchaseConfirmLayer();

    this.oPurchaseConfirmLayer.open();
  };

  /**
   * execCustomDealAction
   * 커스텀딜일 경우, 구매버튼 클릭시 액션을 담당
   */
  execCustomDealAction = () => {
    /* eslint-disable no-underscore-dangle */
    try {
      const { htCustomDealInfo } = TMON.oApp.htStorage.htStaticData;
      const canLogout = !!(
        htCustomDealInfo.canLogout === "true" ||
        htCustomDealInfo.canLogout === true
      );
      if (
        !canLogout && // 로그아웃 상태에서 구매 가능한지 여부
        !TMON.bLogin // 로그인 여부
      ) {
        this.setCustomDealActionStorage(true); // 로그인 전에 localStorage 에 로그인 후 액션을 설정한다. (로그인 완료하면 다시 커스텀딜 액션 프로세스를 탈 수 있도록)
        TMON.oApp.oUtil.login(); // 로그아웃 상태에서 구매 가능하지 않은데 로그아웃 상태면 프로세스를 멈추고 로그인 페이지로.
        return;
      }

      const {
        maxPurchasableQtyPerPerson,
      } = TMON.oApp.htStorage.htStaticData.htDealInfo; // 1인당 구매가능수량
      if (htCustomDealInfo.user >= maxPurchasableQtyPerPerson) {
        // 구매수량 제한
        alert(
          `1인당 구매제한 수량을 초과하였습니다. 해당 상품은 1인당 ${maxPurchasableQtyPerPerson}개 구매 가능합니다.`
        );
        return;
      }

      if (htCustomDealInfo.sCustomDealAction === "plan") {
        // 기획전 이동
        TMON.oApp.oUtil.redirectPlanning(
          htCustomDealInfo.planId,
          htCustomDealInfo.newWindow
        );
      } else if (TMON.htCommonStaticInfo.deal.isOutLink()) {
        // [SDLUI-421] 일시적으로 redirectUrl 을 사용할 수 없는 장애 이슈로 인해, 해당 딜만 잠깐 하드코딩으로 다른 콜앱을 띄우기로 한다.
        // 해당 장애 상황이 해소되면 (앱에서 수정하거나, 외부 브라우저로 새 창을 띄우는 어드민 기능이 추가되면) 해당 코드블럭을 지워야 한다.
        // [SDLUI-482] 안드로이드 내부 브라우저에서도 redirectUrl 을 사용할 수 있게 되었으나, 구버전 앱 사용자를 위해 해당 코드블럭이 지워지지 못했다.
        // TODO: 충분히 시간이 지난 후, (현재 지원버전 4.7.5부터) 해당 코드블럭을 지워야 한다.
        TMON.app.callApp(
          "event",
          "outLink",
          TMON.util.aup(htCustomDealInfo.buttonUrl, TMON.sAppQuery)
        );
      } else if (htCustomDealInfo.sCustomDealAction === "url") {
        // 링크 이동
        TMON.oApp.oUtil.redirectUrl(
          htCustomDealInfo.buttonUrl,
          htCustomDealInfo.newWindow
        );
      }
    } catch (err) {
      console.error(err);
      alert(
        "죄송합니다. 일시적인 오류입니다. 잠시 후 시도해 주십시오. 문제가 계속되면 고객센터를 통해 문의해 주십시오."
      );
    }
  };

  /**
   * 커스텀딜 액션 수행여부를 로컬스토리지에 할당한다.
   * bSet: true 일 경우 localStorage 에 할당. false 일 경우 기존 localStorage 를 삭제.
   */
  setCustomDealActionStorage = (bSet) => {
    if (bSet) {
      localStorage.setItem("AFTER_LOGIN_CUSTOMDEALACTION", true);
    } else {
      localStorage.removeItem("AFTER_LOGIN_CUSTOMDEALACTION");
    }
  };

  /**
   * 커스텀딜 액션 수행여부가 로컬스토리지에 할당되어 있는지 검사하여 리턴
   */
  getCustomDealActionStorage() {
    return localStorage.getItem("AFTER_LOGIN_CUSTOMDEALACTION");
  }

  buyPayco = () => {
    TMON.oApp.setStorage("validateBuyNow", { type: "payco" });
  };

  buyTmonPay = () => {
    TMON.oApp.setStorage("validateBuyNow", { type: "tmonpay" });
  };

  buyGiftTrigger = () => {
    const { dealType } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    const { isPermanentSales } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    // T, P딜이고, isPermanentSales(상시딜 여부)가 true 일경우
    if (
      ["TICKET", "PIN"].indexOf(dealType) !== -1 &&
      isPermanentSales === true
    ) {
      this.handleShowGiftAlertLayer();
    } else {
      TMON.oApp.setStorage("validateBuyGift", true);
    }
  };

  buyGift = (callback, type) => {
    if (!this.purchaseGuard(this.cartManagerVerify, this.subscriptionVerify)) {
      return;
    }

    if (callback && typeof callback === "function") {
      callback(type);
    }
  };

  handleShowGiftAlertLayer = () => {
    if (this.oGiftAlertLayer) {
      this.oGiftAlertLayer.open();
      return;
    }
    this.oGiftAlertLayer = new GiftAlertLayer();

    this.oGiftAlertLayer.open();
  };

  addToCart = () => {
    if (!TMON.bIsAvailAddToCart) {
      return;
    }

    TMON.oApp.setStorage("validateAddToCart");
  };

  purchaseGuard = (...validFn) => {
    const executor = new ValidCompose(this.afterTask);
    return executor.setTasks(...validFn).tirgger();
  };

  cartManagerVerify = (payload) => {
    if (!TMON.oApp.oInnerCartManager.isValidBundleOpt()) 
      throw new InvalidTaskError(ERROR_MESSAGE.IS_BUNDLE_ONLY);
    
    if (
      !TMON.oApp.oInnerCartManager.isValidMaxMinCount() ||
      TMON.oApp.oInnerCartManager.isValidGiftSurgeSale()
    )
      throw new InvalidTaskError(ERROR_MESSAGE.IS_CART_EMPTY);

    return payload;
  };

  subscriptionVerify = (payload) => {
    if (this.isSubsDeal && !TMON.bLogin) {
      throw new InvalidTaskError(ERROR_MESSAGE.IS_NOT_LOGIN);
    }

    return payload;
  };

  subscriptionConfirm = (type) => {
    this.reqType = type;

    TMON.oApp.oApi.fetchApi("subscriptionConfirm", {
      mNo: TMON.memberNo || "",
      dealNo: TMON.oApp.getStorage().htStaticData.sDealNo,
      reqType: type,
    });
  };

  subscriptionResult = (payload) => {
    const {
      httpCode,
      data: { subsDealValid, subsStatus },
    } = TMON.oApp.getStorage().subscriptionConfirm;

    if (httpCode !== 200) {
      throw new InvalidTaskError(ERROR_MESSAGE.SUBS_ERROR_RESV);
    }

    if (subsStatus === "SUBS_CNCL_RESV" && !subsDealValid) {
      throw new InvalidTaskError(ERROR_MESSAGE.SUBS_CNCL_RESV);
    } else if (
      [
        "NONE_SUBS",
        "SUBS_CNCL_DONE",
        "SUBS_IMDT_CNCL",
        "SUBS_TAKE_BACK",
        "LAST_PAY_FAIL",
        "SUBS_END",
      ].includes(subsStatus) &&
      !subsDealValid
    ) {
      throw new InvalidTaskError(ERROR_MESSAGE.SUBS_NOT_MEMBER_RESV);
    } else if (
      ["SUBSCRIBING", "SUBS_CNCL_APPV", "PRID_PAY_FAIL"].includes(subsStatus) &&
      subsDealValid
    ) {
      return payload;
    } else {
      throw new InvalidTaskError(ERROR_MESSAGE.SUBS_ERROR_RESV);
    }
  };

  subscriptionConfirmResult = () => {
    const isValid = this.purchaseGuard(this.subscriptionResult);

    if (!isValid) return;

    const reqType = TMON.oApp.getStorage().subscriptionConfirm.htParams.reqType;

    if (reqType === "buy") {
      this.buyTrigger();
    } else if (reqType === "gift") {
      this.buyGiftTrigger();
    }
  };

  afterTask = (payload) => {
    if (!(payload instanceof InvalidTaskError)) return true;
    let result = false;

    switch (payload.type) {
      case ERROR_MESSAGE.SUBS_ERROR_RESV:
        alert(
          "요청이 많아 처리가 지연되었습니다. 잠시 후에 다시 시도해 주시기 바랍니다."
        );
        break;
      case ERROR_MESSAGE.IS_SOLD_OUT:
        alert("매진된 상품입니다.");
        break;
      case ERROR_MESSAGE.IS_HAVE_SOLD_OUT:
        if (
          confirm(
            "일시 품절이거나 매진된 상품이 포함되어 있습니다. 구매할 수 없는 상품을 제거하고 구매하시겠습니까?"
          )
        ) {
          result = true;
        }
        break;
      case ERROR_MESSAGE.IS_NOT_LOGIN:
        TMON.oApp.oUtil.login();
        break;
      case ERROR_MESSAGE.IS_GIFT_CARD_DEAL:
        this.handleShowPurchaseConfirmLayer();
        break;
      case ERROR_MESSAGE.SUBS_CNCL_RESV:
        new SubscriptionLayer("SUBS_CNCL_RESV").open();
        break;
      case ERROR_MESSAGE.SUBS_NOT_MEMBER_RESV:
        new SubscriptionLayer("SUBS_NOT_MEMBER_RESV").open();
        break;
      case ERROR_MESSAGE.IS_CART_EMPTY:
        break;
      case ERROR_MESSAGE.IS_BUNDLE_ONLY:
        alert("추가구매상품은 단독 구매할 수 없습니다. 이 상품의 다른 옵션과 함께 구매해주세요.");
        break;
      default:
        result = true;
        return result;
    }

    return result;
  };
}
